import clsx from "clsx";
import React, { useContext, useEffect, useRef } from "react";
import { AppContext } from "../../../context/appContext";

const className = 'w-4 h-4 rounded-full';

function WaitingResponse() {
  const ref = useRef(null);
  const {widgetConfig} = useContext(AppContext);
  const waitingResponse = widgetConfig?.customStyles ? widgetConfig.customStyles.waitingResponse : {};

  useEffect(() => {
    if (!!ref.current) {
      ref.current.parentNode.parentNode.parentNode.firstChild.hidden = true;
    }
  }, [ref])

  return (
    <div className="flex h-10 items-center">
      <style>
        {`
          @keyframes bounce2 {
            0%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-3px);
            }
          }
        `}
      </style>

      <div ref={ref} className="typing-dots flex space-x-1">
        <div className={clsx(className, waitingResponse?.backgroundColor ? `bg-[${waitingResponse?.backgroundColor}]`: 'bg-[#7CA4FF]')} style={{ animation: "bounce2 0.6s infinite" }} />
        <div className={clsx(className, waitingResponse?.backgroundColor ? `bg-[${waitingResponse?.backgroundColor}]`: 'bg-[#7CA4FF]')} style={{ animation: "bounce2 0.6s infinite", animationDelay: "0.2s" }}/>
        <div className={clsx(className, waitingResponse?.backgroundColor ? `bg-[${waitingResponse?.backgroundColor}]`: 'bg-[#7CA4FF]')} style={{ animation: "bounce2 0.6s infinite", animationDelay: "0.4s" }}/>
      </div>   
      
      {/* <div ref={ref} className="typing-dots flex space-x-1">
        <div className={clsx(className, waitingResponse?.backgroundColor ? `bg-[${waitingResponse?.backgroundColor}]`: 'bg-gray-500')} style={{ animation: "bounce2 0.6s infinite" }} />
        <div className={clsx(className, waitingResponse?.backgroundColor ? `bg-[${waitingResponse?.backgroundColor}]`: 'bg-gray-500')} style={{ animation: "bounce2 0.6s infinite", animationDelay: "0.2s" }}/>
        <div className={clsx(className, waitingResponse?.backgroundColor ? `bg-[${waitingResponse?.backgroundColor}]`: 'bg-gray-500')} style={{ animation: "bounce2 0.6s infinite", animationDelay: "0.4s" }}/>
      </div>   */}
    </div>
  )
}

export default WaitingResponse;
